import React from 'react';
import { Link } from 'react-router-dom';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="bg-[#FFF8F5] py-12">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1 className="font-heading text-3xl md:text-4xl font-black text-slate-900">Cookie Policy</h1>
          <p className="text-slate-500 mt-2">Informativa sull'utilizzo dei cookie</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 prose prose-slate max-w-none">
        <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <h2 className="font-heading text-xl font-bold text-slate-900">1. Cosa sono i Cookie</h2>
        <p>I cookie sono piccoli file di testo che i siti web visitati inviano al terminale dell'utente (computer, tablet, smartphone), dove vengono memorizzati per poi essere ritrasmessi agli stessi siti in occasione di visite successive. I cookie sono utilizzati per diverse finalità e hanno caratteristiche diverse.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">2. Tipologie di Cookie utilizzati</h2>
        
        <h3 className="font-heading text-lg font-semibold text-slate-800 mt-6">2.1 Cookie Tecnici (necessari)</h3>
        <p>Questo sito utilizza esclusivamente <strong>cookie tecnici</strong> strettamente necessari al funzionamento del sito e alla fornitura del servizio. Questi cookie non richiedono il consenso dell'utente ai sensi dell'art. 122, comma 1 del Codice Privacy.</p>
        <p>In particolare utilizziamo:</p>
        <ul className="list-disc pl-6 space-y-2 text-slate-600">
          <li><strong>Cookie di sessione del carrello:</strong> memorizzano temporaneamente i prodotti aggiunti al carrello durante la navigazione (localStorage: <code>cbm_cart</code>)</li>
          <li><strong>Cookie di preferenza cookie banner:</strong> memorizzano la scelta dell'utente riguardo l'accettazione dei cookie, per evitare di mostrare il banner ad ogni visita (localStorage: <code>cbm_cookies_accepted</code>)</li>
        </ul>

        <h3 className="font-heading text-lg font-semibold text-slate-800 mt-6">2.2 Cookie di Profilazione</h3>
        <p><strong>Questo sito NON utilizza cookie di profilazione.</strong> Non effettuiamo alcuna attività di tracciamento, profilazione o remarketing degli utenti.</p>

        <h3 className="font-heading text-lg font-semibold text-slate-800 mt-6">2.3 Cookie di Terze Parti</h3>
        <p><strong>Questo sito NON utilizza cookie di terze parti</strong> per finalità di marketing o analytics. L'unico servizio esterno utilizzato è <strong>Stripe</strong> per l'elaborazione dei pagamenti, che può installare cookie tecnici necessari alla sicurezza della transazione.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">3. Durata dei Cookie</h2>
        <table className="w-full text-sm border-collapse mt-4">
          <thead>
            <tr className="bg-slate-100">
              <th className="text-left p-3 font-semibold">Cookie</th>
              <th className="text-left p-3 font-semibold">Finalità</th>
              <th className="text-left p-3 font-semibold">Durata</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t border-slate-200">
              <td className="p-3"><code>cbm_cart</code></td>
              <td className="p-3">Carrello acquisti</td>
              <td className="p-3">Persistente (fino a cancellazione manuale)</td>
            </tr>
            <tr className="border-t border-slate-200">
              <td className="p-3"><code>cbm_cookies_accepted</code></td>
              <td className="p-3">Preferenza cookie</td>
              <td className="p-3">Persistente (fino a cancellazione manuale)</td>
            </tr>
          </tbody>
        </table>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">4. Come gestire i Cookie</h2>
        <p>L'utente può gestire le preferenze relative ai cookie direttamente all'interno del proprio browser, disabilitandoli in tutto o in parte. Ecco i link alle istruzioni per i browser più diffusi:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#0288D1]">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-[#0288D1]">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#0288D1]">Safari</a></li>
          <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#0288D1]">Microsoft Edge</a></li>
        </ul>
        <p className="mt-4">La disabilitazione dei cookie tecnici potrebbe compromettere il funzionamento del carrello e del processo di acquisto.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">5. Base Giuridica</h2>
        <p>Il trattamento dei dati tramite cookie tecnici si basa sul <strong>legittimo interesse</strong> del titolare del trattamento (Art. 6, par. 1, lett. f del Regolamento UE 2016/679), in quanto strettamente necessari all'erogazione del servizio richiesto dall'utente.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">6. Titolare del Trattamento</h2>
        <p><strong>A.S.D. Caribbean Blue Moon Dance School</strong><br/>
        Sede Legale: Via Ambra 19, 58100 Grosseto (GR)<br/>
        P.IVA/C.F.: 01770860532<br/>
        Email/PEC: <a href="mailto:caribbean.bluemoon2025@gmail.com" className="text-[#0288D1]">caribbean.bluemoon2025@gmail.com</a></p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">7. Aggiornamenti</h2>
        <p>La presente Cookie Policy può essere aggiornata periodicamente. Invitiamo l'utente a consultare questa pagina regolarmente per eventuali modifiche.</p>

        <div className="mt-12 pt-8 border-t border-slate-200 flex gap-6">
          <Link to="/privacy" className="text-[#0288D1] font-heading font-semibold hover:text-[#FF7043] transition-colors">
            Privacy Policy
          </Link>
          <Link to="/condizioni-vendita" className="text-[#0288D1] font-heading font-semibold hover:text-[#FF7043] transition-colors">
            Termini e Condizioni
          </Link>
          <Link to="/" className="text-[#0288D1] font-heading font-semibold hover:text-[#FF7043] transition-colors">
            ← Torna alla Home
          </Link>
        </div>
      </div>
    </div>
  );
}
